/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
class ParticipantsGrid {
  setSelector(selector) { return this._selector = selector; }
  getSelector() { return this._selector; }
  element() { return $(this.getSelector())[0]; }

  nameRenderer(params) {
    let html =
      params.data.type === 'company' ?
        `<div class='avatar'><img src='${params.data.logo_url}' /></div>` +
        `<a class='company-name' href='${params.data.url}' ${this.companytooltipRenderer(params)}>${params.data.name}</a>`
        :
        "<div class='level-down'></div>" +
        `<div class='avatar default'><div class='initials'>${params.data.initials}</div></div>` +
        `<span class='user-name' data-tooltip='' title='${this.tooltipRenderer(params)}'>${params.data.name}</span>`;

    if ((params.data.type === 'user') && params.data.is_current) {
      html += ` <span>(${I18n.t('you')})</span>`;
    } else if (!!params.data.impersonate_url) {
      html += `<a href='${params.data.impersonate_url}' data-method='post' title='Login As' class='button clear icon-btn pt-signin nano'></a>`;
    }
    return html;
  }

  companytooltipRenderer(params) {
    if (!params.data.employment) {
      return 'data-tooltip="" title="' + params.data.tooltip + '"';
    }
    params = {
      data: params.data.employment,
      prequalified: params.data.pre_qualified
    };
    const title = this.tooltipRenderer(params, true);
    return `data-tooltip='' title='${title}'`;
  }

  tooltipRenderer(params, name) {
    if (name == null) { name = false; }
    const email = params.data.email || I18n.t('not_provided');
    const phone = params.data.phone || I18n.t('not_provided');
    const jobTitle = params.data.job_title || I18n.t('not_provided');
    const keyContact = params.prequalified ? I18n.t('key_contact') : '';

    const nameRow = name ?
      `<div class\"row\">${params.data.name}</div>`
      :
      '';
    let value = `<div>
<div class=\"row\">${keyContact}<\/div>
${nameRow}
<div class=\"row\">
${I18n.t('email')}: ${email}
</div>
<div class=\"row\">
${I18n.t('telephone')}: ${phone}
</div>`;

    if (!params.prequalified) {
      value += `<div class=\"row\">
${I18n.t('job_title')}: ${jobTitle}
</div>`;
    }
    return value + "</div>";
  }

  rolesRenderer(params) {
    if (params.data.type === 'company') {
      return `<div class='company-roles'>${params.data.roles}</div>`;
    } else {
      return params.data.roles;
    }
  }

  statusRenderer(params) {
    if (!params.data.status) { return ''; }
    const klass =
      params.data.status === 'accepted' ?
        'pt-green'
        : params.data.status === 'declined' ?
          'pt-red'
          :
          '';
    let statusHtml = `<span class='${klass}'>${I18n.t(`company_invitation_states.${params.data.status}`)}</span>`;
    if (params.data.email_status) {
      statusHtml = statusHtml + `<i class='pti pt-info pt-gray' data-tooltip='' title='Email Status: ${params.data.email_status}'></i>`;
    }
    return statusHtml;
  }

  createdAtRenderer(params) {
    const m = moment(params.data.created_at);
    return m.format('MMM D, YYYY');
  }

  updatedAtRenderer(params) {
    if (!!params.data.updated_at) {
      const m = moment(params.data.updated_at);
      return m.format('MMM D, YYYY');
    } else {
      return '';
    }
  }

  actionsRenderer(params) {
    if (params.data.actions) {
      let html = "<div class='row-actions actions to-middle'>";

      const pdfUrl = params.data.actions.pdf_url;
      if (pdfUrl) {
        const pdfLink = `<a href='${[pdfUrl, moment().valueOf()].join('&')}' class='button icon-btn pt-pdf nano xsmall-right-buffer'></a>`;
        html += pdfLink;
      }

      const destroyUrl = params.data.actions.destroy_url;
      if (destroyUrl) {
        const destroyLink = `<a href='${[destroyUrl, moment().valueOf()].join('&')}' class='button icon-btn pt-delete nano participant-delete' title='${'Remove'}' data-reveal-id='modalContent' data-reveal-ajax='true'></a>`;
        html += destroyLink;
      }

      const optoutUrl = params.data.actions.optout_url;
      if (optoutUrl) {
        const optoutLink = `<a href='${[optoutUrl, moment().valueOf()].join('&')}' class='button icon-btn pt-signout nano participant-delete' title='${I18n.t('participants.opt_out_from_tender')}' data-reveal-id='modalContent' data-reveal-ajax='true'></a>`;
        html += optoutLink;
      }

      const acceptUrl = params.data.actions.accept_url;
      if (acceptUrl) {
        html += `<a href='${acceptUrl}' class='accept icon-btn button pt-green nano pt-approv-fill tip-left' title='${I18n.t('accept')}' data-reveal-id='modalContent' data-reveal-ajax='true' data-tooltip=''></a>`;
      }

      const declineUrl = params.data.actions.decline_url;
      if (declineUrl) {
        html += `<a href='${declineUrl}' class='decline icon-btn button small-left-buffer pt-red nano pt-reject-fill tip-left' title='${I18n.t('decline')}' data-reveal-id='modalContent' data-reveal-ajax='true' data-tooltip=''></a>`;
      }

      return html += '</div>';

    } else {
      return '';
    }
  }

  setGridOptions() {
    return this._gridOptions = {
      headerHeight: 44,
      rowHeight: 44,
      suppressMovableColumns: true,
      domLayout: 'autoHeight',
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onRowGroupOpened: _.bind(this.onRowGroupOpened, this),
      onGridReady(e) {
        return e.api.sizeColumnsToFit();
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      },
      getNodeChildDetails(data) {
        if ((data.type === 'company') && !_.isEmpty(data.users)) {
          return {
            group: true,
            children: data.users,
            expanded: true
          };
        }
      },
      columnDefs: [
        {
          headerName: I18n.t('v4.participants.index.company_user'),
          field: 'name',
          cellRenderer: 'agGroupCellRenderer',
          width: 600,
          cellRendererParams: {
            innerRenderer: _.bind(this.nameRenderer, this)
          }
        },
        {
          headerName: I18n.t('v4.participants.index.role'),
          width: 250,
          field: 'roles',
          cellRenderer: this.rolesRenderer
        },
        {
          headerName: 'Status',
          width: 250,
          field: 'status',
          cellRenderer: this.statusRenderer
        },
        {
          headerName: 'Create',
          field: 'created_at',
          sort: 'asc',
          cellRenderer: this.createdAtRenderer
        },
        {
          headerName: 'Update',
          field: 'updated_at',
          cellRenderer: this.updatedAtRenderer
        },
        {
          headerName: 'Actions',
          field: 'actions',
          sortable: false,
          width: 130,
          cellRenderer: this.actionsRenderer
        }
      ]
    };
  }

  getGridOptions() {
    return this._gridOptions;
  }

  initializeGrid() {
    this._gridApi = agGrid.createGrid(this.element(), this.getGridOptions());
    this._gridOptions.api = this._gridApi;
    return this._gridApi;
  }

  setData(data) {
    return this._gridApi.setGridOption('rowData', data);
  }

  onRowGroupOpened() {
    this.resize();
    return $('.user-name').foundation('tooltip');
  }

  resize() {
    this.resizeHorizontally();
    return this.resizeVertically();
  }

  resizeVertically() {
    return resizeAgGridTable(this.getSelector(), this.getGridOptions());
  }

  resizeHorizontally() {
    // duplicated and put into timeout to workaround weird behavior
    const sizeToFit = () => this._gridApi.sizeColumnsToFit();
    sizeToFit();
    return setTimeout(sizeToFit, 500);
  }

  initializeListeners() {
    $(window).resize(() => this.resize());
    return $('.collapse-sidebar').click(() => this.resize());
  }

  constructor(options) {
    if (options == null) { options = {}; }
    this.setSelector(options.selector);
    this.setGridOptions();
    this.initializeGrid();
    this.setData(options.data);
    this.resize();
    this.initializeListeners();
  }
}

module.exports = ParticipantsGrid;
